import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getLanguageFromPathname, getPageConfigFromPathname, SITE_DOMAIN, getAlternatePath } from '../i18n/routes';

export function SEO({ title: customTitle, description: customDescription }) {
  const { pathname } = useLocation();
  const lang = getLanguageFromPathname(pathname);
  const pageConfig = getPageConfigFromPathname(pathname);

  const title = customTitle || (pageConfig ? pageConfig[lang].title : "Mette Brudvig");
  const description = customDescription || (pageConfig ? pageConfig[lang].description : "Mette Brudvig - Ny Tids Lederskab & Bevidsthed");

  const canonicalUrl = `${SITE_DOMAIN}${pathname === '/' ? '' : pathname}`;
  const daUrl = `${SITE_DOMAIN}${getAlternatePath(pathname, 'da')}`;
  const enUrl = `${SITE_DOMAIN}${getAlternatePath(pathname, 'en')}`;

  useEffect(() => {
    // Set document lang attribute
    document.documentElement.lang = lang;

    // Set document title
    document.title = title;

    // Helper to set or create meta/link tag
    const setMetaTag = (name, content) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const setOgMetaTag = (property, content) => {
      let el = document.querySelector(`meta[property="${property}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', property);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const setLinkTag = (rel, href, hreflang = null) => {
      const selector = hreflang 
        ? `link[rel="${rel}"][hreflang="${hreflang}"]` 
        : `link[rel="${rel}"]:not([hreflang])`;
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement('link');
        el.setAttribute('rel', rel);
        if (hreflang) el.setAttribute('hreflang', hreflang);
        document.head.appendChild(el);
      }
      el.setAttribute('href', href);
    };

    // Meta descriptions
    setMetaTag('description', description);
    setOgMetaTag('og:title', title);
    setOgMetaTag('og:description', description);
    setOgMetaTag('og:url', canonicalUrl);
    setOgMetaTag('og:locale', lang === 'en' ? 'en_US' : 'da_DK');

    // Canonicals and hreflangs
    setLinkTag('canonical', canonicalUrl);
    setLinkTag('alternate', daUrl, 'da');
    setLinkTag('alternate', enUrl, 'en');
    setLinkTag('alternate', daUrl, 'x-default');

    // Track pageview in Meta Pixel on route change
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }

  }, [pathname, lang, title, description, canonicalUrl, daUrl, enUrl]);

  return null;
}

export default SEO;
